import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { useBrand } from "@/hooks/useBrand";
import conectaLight from "@/assets/brand/prime-conecta-horizontal.svg";
import conectaDark from "@/assets/brand/prime-conecta-white.svg";
import { BrandSymbol } from "@/components/brand/BrandSymbol";
import { cn } from "@/lib/utils";
import logoLight from "@/assets/brand/prime-telefonia-cropped.png";
import logoDark from "@/assets/brand/prime-telefonia-cropped-dark.png";

type BrandMarkProps = {
  className?: string;
  imgClassName?: string;
  title?: string;
  collapsed?: boolean;
  /** Fundo escuro fixo (ex.: sidebar vinho) — usa sempre o logo branco, independe do tema. */
  onDark?: boolean;
};

/** Logo do topo da sidebar / telas de auth — troca light/dark conforme tema. */
export default function BrandMark({
  className,
  imgClassName,
  title,
  collapsed = false,
  onDark = false,
}: BrandMarkProps) {
  const { resolvedTheme } = useTheme();
  const { brand, isConecta, isLoadingBrand } = useBrand();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const logoTitle = title || (isConecta ? "Prime Conecta" : "Prime Telefonia Empresarial");
  // Antes do mount evita hydration mismatch — assume light, troca após mount.
  const dark = onDark || (mounted && resolvedTheme === "dark");
  const logoSrc = isConecta ? (dark ? conectaDark : conectaLight) : (dark ? logoDark : logoLight);

  return (
    <a href="/" aria-label={logoTitle} className={cn("inline-flex items-center", className)}>
      {collapsed ? <BrandSymbol brand={brand} className="h-9 w-9" /> : <img
        src={logoSrc}
        alt={logoTitle}
        className={cn(
          "transition-all",
          collapsed
            ? "h-12 w-12 object-contain object-left"
            : "h-16 w-full max-w-[220px] object-contain",
          imgClassName,
          isLoadingBrand && "invisible",
        )}
      />}
    </a>
  );
}
